import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=3b1120ea&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=3b1120ea&prod&lang=stylus&scoped=true"
import style1 from "./Index.vue?vue&type=style&index=1&id=3b1120ea&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1120ea",
  null
  
)

export default component.exports